import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { banksActions } from '../../../application/actions/banks';

import api from '../../api';

const apiBanks = api(process.env.REACT_APP_BANKS_API);

export function* fetchBanks(action) {
  try {
    const { data } = yield call(apiBanks.get, 'v1/consultar', action.payload);

    if (data) yield put(banksActions.fetchBanksSuccess({data}));
    else yield put(banksActions.fetchBanksError());
  } catch (err) {
    console.error('banks saga error:', err);
    yield put(banksActions.fetchBanksError());
  }
}

export function* watchFetchBanks() {
  yield takeLatest(banksActions.fetchBanks.type, fetchBanks);
}
/* istanbul ignore next */
export default function* banksSaga() {
  yield spawn(watchFetchBanks);
}
